<template>
    <div>
        <section class="emailcheck">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1">
                        <v-card>
                            <v-card-title class="headline">Ověření e-mailu</v-card-title>
                                <v-card-text>
                                <v-alert
                                v-if="user && user.activated"
                                type="info"
                                >
                                    E-mail ověřen
                                </v-alert>
                                <v-alert
                                v-else
                                type="error"
                                >
                                    <v-row align="center" dense>
                                        <v-col class="grow">E-mail neověřen</v-col>
                                            <v-col class="shrink">
                                                <v-btn
                                                small
                                                :loading="loading"
                                                :disabled="loading"
                                                @click.prevent="resendActivationEmail"
                                                >
                                                    Znovu odeslat
                                                </v-btn>
                                            </v-col>
                                    </v-row>
                                </v-alert>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { RESEND_ACTIVATION_EMAIL_REQUEST } from '../../store/actions/user'

    export default {
        name: 'UserActivation',
        data () {
            return {
                loading: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
        },
        methods: {
            async resendActivationEmail () {
                try {
                    this.loading = true;
                    await this.$store.dispatch('user/' + RESEND_ACTIVATION_EMAIL_REQUEST);
                    this.$toast.success('Aktivační e-mail byl úspěšně odeslán.');
                } catch (e) {
                    const message = e.response.data.message || 'Došlo k chybě při odeslání aktivačního e-mailu. ';
                    this.$toast.error(message);
                } finally {
                    this.loading = false;
                }
            },
        },
    }
</script>
